<template>
    <div id="cms">
        <modals-container></modals-container>
        <cms-sidebar></cms-sidebar>
        <router-view></router-view>
    </div>
</template>

<script>
  import CmsSideBar from './cms/CmsSidebar'
  import OkModal    from './modals/OkModal'

  export default {
    name: 'Cms',
    components: {
      'cms-sidebar': CmsSideBar
    },
    mounted () {
      // check if user is active
      if (!this.$store.getters.getAuth['passwordChanged']) {
        this.$modal.show(OkModal, {
            text: this.$t('message.activateAccount'),
            modalClass: this.modalClasses.okSuccessClass
          },
          {
            width: this.modalWidth(),
            height: 'auto'
          })
      }

      this.get(this.apiPrefix, this.userApiUrl + '/', this.$store.getters.getAuth['userId'])
        .then(resp => {
          const firstName = resp.data.first_name !== null ? resp.data.first_name : ''
          const lastName = resp.data.last_name !== null ? resp.data.last_name : ''
          this.$store.commit('setFullName', `${firstName} ${lastName}`)
          if (resp.data.profile_image && resp.data.profile_image.image) {
            this.$store.commit('setProfileImage', resp.data.profile_image.image)
          }
        })
        .catch(err => {
          console.log(err.response)
        })
    }
  }
</script>

<style scoped>

</style>